<template>
  <div>
    <div class="mdl-grid center-items">
      <!-- <div class="mdl-cell mdl-cell--4-col"></div> -->
      <div class="mdl-cell mdl-cell--4-col mdl-cell--6-col-phone mdl-card mdl-shadow--6dp">
    			<div class="mdl-card__title mdl-color--blue-grey-900 mdl-color-text--blue-grey-50">
    				<h2 class="mdl-card__title-text">Create Account</h2>
    			</div>
    			<div class="mdl-cell mdl-cell--12-col mdl-card__supporting-text">
    				<form>
    					<div class="mdl-cell mdl-cell--12-col mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
    						<input class="mdl-textfield__input" type="text" id="email" v-model="email"/>
    						<label class="mdl-textfield__label mdl-color-text--blue-grey-500" for="email">Email</label>
    					</div>
    					<div class="mdl-cell mdl-cell--12-col mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
    						<input class="mdl-textfield__input" type="password" id="userpass" v-model="password"/>
    						<label class="mdl-textfield__label mdl-color-text--blue-grey-500" for="userpass">Password</label>
    					</div>
    				</form>
    			</div>
    			<div class="mdl-card__actions mdl-card--border">
    				<button class="mdl-color-text--blue-grey-900 mdl-cell mdl-cell--12-col mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect"
              @click.prevent="signUp">
              Login
            </button>
    			</div>
    	</div>
      <!-- <div class="mdl-cell mdl-cell--4-col"></div> -->
    </div>

    <div class="mdl-grid center-items">
      <!-- <div class="mdl-cell mdl-cell--4-col"></div> -->
      <div class="mdl-cell mdl-cell--4-col mdl-cell--6-col-phone mdl-card mdl-shadow--6dp">
			    <div class="mdl-cell mdl-cell--12-col mdl-card__supporting-text">
				    <span>To log in <router-link class="mdl-color-text--blue-grey-700" to="/login">login</router-link>.</span>
			    </div>
				    <button class="mdl-card__actions mdl-color-text--blue-grey-900 mdl-cell mdl-cell--12-col mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect" @click.prevent="signInWithGoogle">
              Login with Google
            </button>
		  </div>
      <!-- <div class="mdl-cell mdl-cell--4-col"></div> -->
    </div>
  </div>
</template>

<script>
import db from '../main.js'
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'

export default {
  name: 'signUp',
  data: function () {
    return {
      email: '',
      password: ''
    }
  },
  methods: {
    signUp: function () {
      firebase.auth().createUserWithEmailAndPassword(this.email, this.password).then(
        (user) => {
          this.saveToFirestore()
          this.$router.replace('home')
        },
        (err) => {
          alert('Oops. ' + err.message)
        }
      )
    },
    saveToFirestore: function () {
      // console.log(firebase.auth().currentUser)
      let currentUserInfo = {
        displayName: firebase.auth().currentUser.displayName,
        email: firebase.auth().currentUser.email,
        emailVerified: firebase.auth().currentUser.emailVerified,
        phoneNumber: firebase.auth().currentUser.phoneNumber,
        photoURL: firebase.auth().currentUser.photoURL,
        providerId: firebase.auth().currentUser.providerData[0].providerId
      }
      db.collection('users').doc(firebase.auth().currentUser.uid).set(currentUserInfo, { merge: true })
        .then(function () {
          console.log('Document successfully written!')
        })
        .catch(function (error) {
          console.error('Error writing document: ', error)
        })
    }
  },
  created () {
    this.$nextTick(() => {
      window.componentHandler.upgradeDom()
      window.componentHandler.upgradeAllRegistered()
    })
  }
}
</script>

<style scoped>
.mdl-card{
  /* margin-bottom: 10px; */
  min-height: 120px;
}
</style>



// WEBPACK FOOTER //
// src/components/SignUp.vue